<template>
<div class="store_section" v-if="get_born_to_ride">
    <div class="img_section" :style="`background-image: url(${get_born_to_ride.image});`">
        <h1>{{get_born_to_ride.title}}</h1>
    </div>
    <div class="text_story">
        <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="text_left">
                    <h1>{{get_our_story.title}}</h1>
                    <h4>{{get_our_story.subtitle}}</h4>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="text-right">
                    <p class="desc" v-html="get_our_story.description"></p>
                </div>
            </div>
        </div>
    </div>
    </div>
    
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "storeArea",
      computed:{
    ...mapGetters({
        get_our_story:'get_our_story',
        get_born_to_ride:'get_born_to_ride'
    })
  },
    methods:{
    ...mapActions({
       our_story_api:'our_story_api',
       born_to_ride_api:'born_to_ride_api'
    }),
    },
    mounted(){
        this.born_to_ride_api();
       this.our_story_api();
    }
}
</script>
<style lang="scss" scoped>
.img_section{
    background-size: cover;
    background-position: center center;
    // background-attachment: fixed;
    height: 405px;
    position: relative;
    &::after{
        content: '';
    background-color: rgb(27, 27, 27);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        color: white;
        line-height: 1.1;
        font-size: 2.5rem;
        font-family: 'Oswald',sans-serif;
        text-transform: uppercase;
        font-weight: 700;
            height: 100%;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 120px;
    }
}
.text_story{
padding: 90px 0px 50px 0px;
background-image: url('~@/assets/what2.svg');
background-position: bottom right;
    background-repeat: no-repeat;
    background-size: 10vw auto;
.text_left{
    h1{
         color: white;
        line-height: 1.1;
        font-size: 2.5rem;
        font-family: 'Oswald',sans-serif;
        text-transform: uppercase;
        font-weight: 700;
        position: relative;
        padding-bottom: 35px;
         &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 80px;
            height: 4px;
            background-color: var(--active_color);
          }
    }
    h4{
    font-size: 1.5rem;
    font-family: 'Oswald',sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    color: white;
    padding: 0px 100px 0px 0px;
    margin: 0;
    margin-top: 32px;
    }
}
.text-right{
    padding-right: 100px;
    padding-top: 50px;
}
}
@media(max-width:767px){
    .img_section {
    background-size: cover;
    background-position: center center;
    height: 250px;
    position: relative;
}
.img_section h1{
    position: relative;
    z-index: 2;
    line-height: 1.1;
    font-size: 2rem;
    padding-top: 20px;
}
.text_story {
    padding: 40px 0px 20px 0px;
}
.text_story .text_left h1 {
    line-height: 1.1;
    font-size: 1.8rem;
    padding-bottom: 25px;
}
}
</style>